import { z } from 'zod';

export const projectStageCountSchema = z.object({
  planning: z.number(),
  installation: z.number(),
  operative: z.number(),
  documentation: z.number(),
  archived: z.number(),
});

export const projectStageKpiSnapshotSchema = z.object({
  snapshotDate: z.string(),
  projectCounts: projectStageCountSchema,
  sensorCounts: projectStageCountSchema,
});

export const projectStageKpiResponseSchema = z.object({
  snapshots: z.array(projectStageKpiSnapshotSchema),
});

export type ProjectStageKpiSnapshot = z.infer<typeof projectStageKpiSnapshotSchema>;
